import styled, { css } from 'styled-components'

export const LoaderWrap = styled.div`
  color: transparent;
  position: ${props => props.fullscreen ? 'fixed' : 'absolute'};
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  text-indent: -9999px;
  z-index: 99991;
  background-color: ${props => props.bgColor};
`

export const LoaderAnimate = styled.div`
	background: inherit;
	display: inline-block;
	position: absolute;
	left: 50%;
	top: 50%;
`

export const LoaderMessage = styled.div` 
  text-indent: 0;
  color: ${props => props.color};
  font-size: ${props => props.fontSize};
  ${props => css`
    width: 100%;
    top: calc(50% + ${props.itemSize * 0.75}px);
    /*
    width: ${props.itemSize * 1.5}px
    top: calc(50% + ${props.itemSize * 0.75}px);
    left: calc(50% - ${props.itemSize * 0.75}px);
    */
  `};
  text-align: center;
  position: relative;
`

export const StyledLoader = styled.div`
  & > svg {
    display: inline-block;
    position: absolute;
  ${props => css`
    top: calc(50% - ${props.itemSize / 2}px);
    left: calc(50% - ${props.itemSize / 2}px);
  `};
    overflow: show;
    margin: auto;
    text-indent: -9999em;
    animation: spin 1.5s linear infinite;

    fill: ${props => props.itemColor};
    height: ${props => props.itemSize}px;
    width: ${props => props.itemSize}px;
    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
`
